export const FETCH_REQUEST = "CLIENTS_FETCH_REQUEST";
export const FETCH_SUCCESS = "CLIENTS_FETCH_SUCCESS";
export const FETCH_FAILURE = "CLIENTS_FETCH_FAILURE";

export const INSERT = "CLIENTS_INSERT";

export const DELETE_SUCCESS = "CLIENTS_DELETE_SUCCESS";
